// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"6c7eaf80db895e65","777":"91f2db98a902fff4"}[chunkId] + ".js";
};